import { Icons } from './Icons';
import { LINKS } from '../constants';
import styles from './ProductStrip.module.css';

const ITEMS = [
  { href: LINKS.velarionDex,    icon: Icons.Swap, label: 'Velarion DEX',  accent: '#3B82F6' },
  { href: LINKS.tronEnergySite, icon: Icons.Bolt, label: 'Tron Energy',   accent: '#06B6D4' },
  { href: LINKS.tronEnergyBot,  icon: Icons.Bolt, label: 'Tron Energy Bot', accent: '#3B82F6' },
];

export default function ProductStrip() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <span className={styles.tag}>Products</span>
        <div className={styles.items}>
          {ITEMS.map(({ href, icon: IconComp, label, accent }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.item}
              style={{ '--accent': accent }}
            >
              <span className={styles.icon}><IconComp /></span>
              {label}
              <span className={styles.extLink}><Icons.ExternalLink /></span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
